import { connect } from "react-redux";
import * as React from "react";
import Component from "../../AbstractComponent";

interface StateInterface {
}

class Comment extends Component {
  public state: StateInterface = {
  };

  constructor(public props) {
    super(props);
  }

  public render() {
    return (
			<div 
				className={`comment-wrapper`}
			>
				<div 
          className="comment-inner-wrapper" 
          style={{paddingBottom: "10px"}}
        >
					<div className="header">
            <React.Fragment>
              <div className="name">{this.props.comment?.creatorDisplayName}</div>
              <div className="date">{this.formatter.formatDate(this.props.comment?.createdAt)}</div>
            </React.Fragment>
					</div>
					<div className="comment">
            {this.props.comment?.content?.note}
            <div className="time">
              {this.formatter.formatTime(this.props.comment?.createdAt)}
            </div>
          </div>
				</div>
			</div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  Comment
);
